import api from './api';

export interface Compania {
    idCompania: string;
    nombre: string;
    domicilio?: string;
    cp?: string;
    localidad?: string;
    provincia?: string;
    pais?: string;
    telefono1?: string;
    telefono2?: string;
    fax1?: string;
    fax2?: string;
    mail1?: string;
    mail2?: string;
    condIva?: string;
    cuit?: string;
    logo?: string;
}

export interface CompaniaSearchParams {
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface CompaniaPagedResult {
    items: Compania[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const companiaService = {
    getCompanias: async (params?: CompaniaSearchParams): Promise<Compania[]> => {
        const response = await api.get('/api/Compañias', params ? { params } : {});
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (data && typeof data === 'object' && 'items' in data) {
            return data.items as Compania[];
        }
        return [];
    },

    getCompaniasPaged: async (params: CompaniaSearchParams): Promise<CompaniaPagedResult> => {
        const response = await api.get('/api/Compañias', { params });
        const data = response.data;
        const pageNumber = params.pageNumber || 1;
        const pageSize = params.pageSize || 10;
        
        if (Array.isArray(data)) {
            return {
                items: data,
                totalCount: data.length,
                pageNumber: pageNumber,
                pageSize: pageSize,
                totalPages: Math.ceil(data.length / pageSize)
            };
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return data as CompaniaPagedResult;
        }
        
        return {
            items: [],
            totalCount: 0,
            pageNumber: pageNumber,
            pageSize: pageSize,
            totalPages: 0
        };
    },

    getCompania: async (idCompania: string): Promise<Compania> => {
        const response = await api.get<Compania>(`/api/Compañias/${idCompania}`);
        return response.data;
    },

    createCompania: async (compania: Compania): Promise<Compania> => {
        const response = await api.post<Compania>('/api/Compañias', compania);
        return response.data;
    },

    updateCompania: async (idCompania: string, compania: Compania): Promise<void> => {
        await api.put(`/api/Compañias/${idCompania}`, compania);
    },

    deleteCompania: async (idCompania: string): Promise<void> => {
        await api.delete(`/api/Compañias/${idCompania}`);
    }
};

export default companiaService;
